import { Component } from '@angular/core';

@Component({
	selector: 'rx-simple-form-field',
	templateUrl: './simple-form-field.component.html',
	styleUrls: ['./simple-form-field.component.scss']
})
export class SimpleFormFieldComponent {}
